const CircleAdd = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = `#000`,
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="3969"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zM512 972.8C256 972.8 51.2 768 51.2 512S256 51.2 512 51.2 972.8 256 972.8 512 768 972.8 512 972.8z"
      fill={color}
      p-id="3970"
    ></path>
    <path
      d="M774.4 486.4 537.6 486.4 537.6 249.6c0-12.8-12.8-25.6-25.6-25.6S486.4 236.8 486.4 249.6l0 236.8L249.6 486.4C236.8 486.4 224 499.2 224 512c0 12.8 12.8 25.6 25.6 25.6l236.8 0 0 236.8c0 12.8 12.8 25.6 25.6 25.6s25.6-12.8 25.6-25.6L537.6 537.6l236.8 0c12.8 0 25.6-12.8 25.6-25.6C800 499.2 787.2 486.4 774.4 486.4z"
      fill={color}
      p-id="3971"
    ></path>
  </svg>
);

export default CircleAdd;
